import Button from "@material-ui/core/Button"
import Grid from "@material-ui/core/Grid"
import makeStyles from "@material-ui/core/styles/makeStyles"
import TextField from "@material-ui/core/TextField"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import ReactDOM from "react-dom"
import React, { Fragment, useContext, useState } from "react"
import IconButton from "@material-ui/core/IconButton"
import AddIcon from "@material-ui/icons/Add"
import SweetAlert from "react-bootstrap-sweetalert"
import { useStyles as useAlertStyles } from "Components/Alert"
import FieldSelect from "Components/Table/FieldSelect"
import { AppContext } from "../Home/context"
import { InitialModal } from "Methods/modal"

interface ComponentProps {
    onRowAdd: (newData: any) => Promise<void>
}
const useStyles = makeStyles({
    ColorBlock: {
        width: "40px",
        height: "15px",
        borderRadius: 4,
        backgroundColor: "red",
        margin: "20px 0",
    },
    btnGroup: {
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
    },
})

const AuthorAdd = (props: ComponentProps) => {
    const classes = useStyles()
    const alertClasses = useAlertStyles()
    const { onRowAdd } = props
    const [ show, setShow ] = useState<boolean>(false)
    const [ authorName, setAuthorName ] = useState<string>("")
    const [ uid, setUid ] = useState<string>("")
    const { handleChangeModal } = useContext(AppContext)
    const handleAddAuthor = () => {
        setShow(true)
    }
    const handleConfirm = async () => {
        await onRowAdd({
            name: authorName,
            uid,
            hidden: false,
        })
        setAuthorName("")
        setUid("")
        setShow(false)
        handleChangeModal({
            show: true,
            type: "success",
            title: "已添加！",
            timeout: 800,
            onConfirm: () => {
                handleChangeModal(InitialModal)
            },
        })
    }
    const handleCancel = () => {
        setAuthorName("")
        setUid("")
        setShow(false)
    }
    const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAuthorName(event.target.value)
    }
    const el: HTMLElement | null = document.querySelector("#article_type_modal")
    const disabled = authorName === ""
    return (
        <Fragment>
            <IconButton onClick={handleAddAuthor}>
                <AddIcon />
            </IconButton>
            {
                el && ReactDOM.createPortal(
                    <SweetAlert
                        type="default"
                        title="添加作者"
                        confirmBtnText="确定"
                        cancelBtnText="取消"
                        disabled={disabled}
                        onConfirm={handleConfirm}
                        customButtons={
                            <span className={classes.btnGroup}>
                                <Button variant="contained" onClick={handleCancel} className={alertClasses.cancelBtn}>
                                    取消
                                </Button>
                                <Button
                                    disabled={disabled}
                                    variant="contained"
                                    className={alertClasses.confirmBtn}
                                    onClick={handleConfirm}
                                >
                                    确定
                                </Button>
                            </span>
                        }
                        show={show}
                    >
                        <Grid container direction="column" justify="center">
                            <TextField label="作者名称" value={authorName} onChange={handleTextChange}/>
                            <br/><br/>
                            <FormControl>
                                <InputLabel>关联用户</InputLabel>
                                <FieldSelect
                                    onChange={(d: any) => {
                                        setUid(d)
                                    }}
                                    rowData={{
                                        users_public_uid: uid,
                                    }}
                                    tableName="users_public"
                                    whereQuery={"where: {hidden: {_eq: false}}"}
                                />
                            </FormControl>
                        </Grid>
                    </SweetAlert>,
                    el,
                )
            }
        </Fragment>
    )
}

export default AuthorAdd
